import { useParams } from '@tanstack/react-router'

import { getCountryFromPath, getLanguageFromPath } from '@/utils/base-path-params'

export function useLocale() {
  const { country, language } = useParams({ strict: false })

  // Prefer reading from params for reactivity, fallback to path-based values
  const locale = `${(language ?? getLanguageFromPath()).toLowerCase()}-${(country ?? getCountryFromPath()).toUpperCase()}`
  return { locale }
}
